import axios from "axios";
import React, { useEffect, useState } from "react";
import MovieList from "./MovieList";

import "./Search.scss";

const Search = ({ searchText, setSearchText }) => {
  // const [mobileView, setMobileView] = useState(false);
  // const [page, setpage] = useState(1);
  const [content, setContent] = useState([]);
  const fetchedSearchData = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/search/movie?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&query=${searchText}&page=1&include_adult=false`
    );
    setContent(data.results);
  };
  // console.log(content);
  useEffect(() => {
    if (searchText) {
      // console.log("calling");
      fetchedSearchData();
    }

    // eslint-disable-next-line
  }, [searchText]);

  return (
    <>
      <div className="search-area">
        <div className="search-area__search-container">
          <input
            type="search"
            placeholder="Search"
            onChange={(e) => setSearchText(e.target.value)}
          ></input>
        </div>
        <div className="search-area__movielist-container">
          {searchText &&
            content?.map((c) => (
              <MovieList
                key={c.id}
                title={c.name || c.title}
                poster={c.poster_path}
              />
            ))}
        </div>
      </div>
    </>
  );
};
export default Search;
